import api from '../helpers';

// Default empty response structure
const EMPTY_KPI_RESPONSE = {
  costAvoidance: [],
  totalLeaks: 0,
  repairedLeaks: 0,
  unrepairedLeaks: 0,
  totalKwh: 0,
  repairedKwh: 0,
  unrepairedKwh: 0,
};

// Transform API response to the format expected by KpiSummaryCards
const transformKpiResponse = (data) => {
  if (!data || typeof data !== 'object') {
    return EMPTY_KPI_RESPONSE;
  }

  try {
    // Transform cost data from object to array format
    const costAvoidance = data.cost
      ? Object.entries(data.cost).map(([currency, values]) => ({
        currency,
        totalLoss: values?.total ?? 0,
        repairedLoss: values?.repaired ?? 0,
        unrepairedLoss: values?.unrepaired ?? 0,
      }))
      : [];

    return {
      costAvoidance,
      totalLeaks: data.leaks?.total ?? 0,
      repairedLeaks: data.leaks?.repaired ?? 0,
      unrepairedLeaks: data.leaks?.unrepaired ?? 0,
      totalKwh: data.energy?.total ?? 0,
      repairedKwh: data.energy?.repaired ?? 0,
      unrepairedKwh: data.energy?.unrepaired ?? 0,
    };
  } catch (err) {
    console.error('Failed to transform KPI response:', err);
    return EMPTY_KPI_RESPONSE;
  }
};

export default {
  getKpi: {
    key: 'fetchKpi',
    query: (filters = {}) => {
      return api.get('/api/kpi', {
        params: {
          startDate: filters.startDate,
          endDate: filters.endDate,
          scope: filters.scope,
        },
      });
    },
    mapper: ({ data }) => transformKpiResponse(data),
  },
};
